import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, EMPTY, lastValueFrom} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {NGXLogger} from 'ngx-logger';
import { environment } from '@environments/environment';

interface Environment {
    production: boolean;
    commitHash: string;
    commitDate: string;
    deployDate: string;
    apiUrl: string;
    paypalClientId: string;
    recaptchaV3SiteKey: string;
    recaptchaV2SiteKey: string;
    [key: string]: any;
}

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    private static readonly _configFileUrlOrLocation = 'assets/config.json';
    private readonly _environment: BehaviorSubject<Environment>;

    constructor(private http: HttpClient, private logger: NGXLogger) {
        this._environment = new BehaviorSubject<Environment>(environment as Environment);
    }

    public get environment(): BehaviorSubject<Environment> {
        return this._environment;
    }

    public loadEnvironment(): Promise<any> {
        return lastValueFrom(
            this.http.get<Partial<Environment>>(EnvironmentService._configFileUrlOrLocation).pipe(
                tap((response) => {
                    this.logger.debug('Loading config: ', response);
                    const env = { ...environment } as Environment;

                    // Save the config to environment vars
                    Object.keys(response).forEach((key) => {
                        // Update or add new properties from config
                        env[key] = response[key];
                    });

                    if (env.commitHash) {
                        console.log('\n\n' +
                            '\tCommit: ' + env.commitHash +'\n' +
                            '\tUpdate Date: ' + env.commitDate +'\n' +
                            '\tDeployment Date: ' + env.deployDate +'\n' +
                            '\n\n'
                        );
                    }
                    
                    this._environment.next(env);
                }),
                catchError(error => {
                    this.logger.error('Error loading config:', error);
                    return EMPTY;
                }),
            ),
        );
    }
}
